export default "__VITE_ASSET__D1w3T5AM__"